import NavigationButtons from "common/NavigationButtons/NavigationButtons";
import Row from "common/Row/Row";
import { useState, useContext } from "react";
import Button from "common/Button/Button";
import DynamicPopup from "common/DynamicPopup/DynamicPopup";
import RowHeader from "common/RowHeader/RowHeader";
import Spinner from "common/Spinner/Spinner";
import { amountFormatter, getRequiredIds, scrollToTop } from "utils/Utilities";
import { useMonthlyPayoutInfoMutation } from "service/APIService";
import ErrorMessage from "common/ErrorMessage/ErrorMessage";

const SubmitElection = ({ context }) => {
  const {
    labels,
    navigate,
    sanitize,
    PDFDownloadLink,
    MyPdfDocument,
    payout,
    participantDetails,
    cancel,
  } = useContext(context);

  const [showPopup, setShowPopup] = useState(false);
  const [errors, setErrors] = useState(null);

  const [monthlyPayoutApi, { isLoading }] = useMonthlyPayoutInfoMutation();

  const submit = () => {
    setErrors(null);
    scrollToTop();

    monthlyPayoutApi({
      ...getRequiredIds(participantDetails),
      schPayoutStartDate: payout?.payoutStartDate,
    })
      .unwrap()
      .then(() => {
        setShowPopup(true);
      })
      .catch((err) => {
        setErrors(err?.data);
      });
  };

  return (
    <section className="section-two monthly-payout">
      {isLoading && <Spinner />}
      {errors && <ErrorMessage error={errors} />}
      <>
        <RowHeader
          header={labels?.monthlyPayoutElection?.monthlyInstallmentPayouts}
          wrapperClassName="mb-2"
        />
        <div className="mb-2">
          {labels?.monthlyPayoutElection?.basedUponStartDate}
        </div>
        <Row
          leftValue={labels?.monthlyPayoutElection?.startDatePayout}
          leftClass="fw-bold col-6"
          rightValue={payout?.payoutStartDate}
          noBorder={true}
        />
        <Row
          leftValue={labels?.monthlyPayoutElection?.initialWithdrawal}
          leftClass="fw-bold col-6"
          rightValue={
            payout?.currentWdlPeriodStartDate +
            " - " +
            payout?.currentWdlPeriodEndDate
          }
          noBorder={true}
        />
        <Row
          leftValue={labels?.monthlyPayoutElection?.estimatedMonthly}
          leftClass="fw-bold col-6"
          rightValue={amountFormatter(payout?.estimatedMonthlyPayoutAmount)}
          noBorder={true}
        />
        <Row
          leftValue={labels?.monthlyPayoutElection?.nextWithdrawal}
          leftClass="fw-bold col-6"
          rightValue={
            payout?.nextWdlPeriodStartDate +
            " - " +
            payout?.nextWldPeriodEndDate
          }
          noBorder={true}
        />
        <Row
          wrapperClassNames="mb-3"
          leftValue={labels?.monthlyPayoutElection?.resetDate}
          leftClass="fw-bold col-6"
          rightValue={payout?.monthlyPayoutResetDate}
          noBorder={true}
        />
        <p>
          {labels?.monthlyPayoutElection?.paymentMayDiffer}
          <br />
          <span className="d-inline-block mt-2">
            {labels?.monthlyPayoutElection?.vestingMsg}
          </span>
        </p>
      </>

      <>
        <RowHeader
          header={labels?.monthlyPayoutElection?.taxWithholding}
          wrapperClassName="mb-2"
        />
        <p
          dangerouslySetInnerHTML={sanitize(
            labels?.monthlyPayoutElection?.taxesMsg
          )}
        ></p>
      </>

      <>
        <RowHeader
          header={labels?.monthlyPayoutElection?.paymentDelivery}
          wrapperClassName="border-bottom-0"
        />
        <p
          dangerouslySetInnerHTML={sanitize(
            labels?.monthlyPayoutElection?.paymentDeliveryMsg
          )}
        ></p>
      </>

      <RowHeader
        header={labels?.monthlyPayoutElection?.initiatePayment}
        wrapperClassName="border-bottom-0"
      />

      <NavigationButtons
        wrapperClassName="py-4 hide-for-pdf"
        leftLabel={labels?.monthlyPayoutElection?.back}
        leftClick={cancel}
        rightLabel={labels?.monthlyPayoutElection?.submit}
        rightClick={submit}
      />

      <DynamicPopup
        showModal={showPopup}
        body={labels?.monthlyPayoutElection?.successMsg}
      >
        <Button
          type="secondary"
          text={labels?.monthlyPayoutElection?.homePage}
          wrapperClassName="py-2"
          ariaLabel="Home Page"
          click={() => navigate("/dashboard")}
        />
        <PDFDownloadLink
          document={<MyPdfDocument />}
          fileName="MonthlyPayout.pdf"
        >
          <Button
            type="download"
            text={labels?.monthlyPayoutElection?.download}
            wrapperClassName="py-2"
            ariaLabel="Download"
          />
        </PDFDownloadLink>
      </DynamicPopup>
    </section>
  );
};

export default SubmitElection;
